// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qfEH","content":"styles_content__1XdLn"};